import React from "react";
import { Box, BoxProps, CircularProgress, CircularProgressProps, Stack, StackProps } from "@mui/material";

interface ProgressOverlayProps {
  spinnerProps?: CircularProgressProps;
  className?: string;
  children: React.ReactNode;
  inProgress: boolean;
  overlaySX?: StackProps["sx"];
  containerSX?: BoxProps["sx"];
  disableOverlayBgc?: boolean;
}

export const ProgressOverlay: React.FC<ProgressOverlayProps> = ({
  spinnerProps,
  className,
  children,
  inProgress,
  overlaySX,
  containerSX,
  disableOverlayBgc = false
}) => (
  <Box className={className} sx={{ position: "relative", ...containerSX }}>
    {inProgress && (
      <Stack
        sx={{
          justifyContent: "center",
          alignItems: "center",
          position: "absolute",
          width: "100%",
          height: "100%",
          ...(!disableOverlayBgc && { bgcolor: "rgb(231, 231, 231)" }),
          opacity: 0.3,
          zIndex: 100,
          top: 0,
          left: 0,
          ...overlaySX
        }}
      >
        <CircularProgress {...spinnerProps} />
      </Stack>
    )}
    {children}
  </Box>
);
